<template>
  <div :class="{ marTop: marTop, marTop2: !marTop }">
    <div class="banner" v-if="marketBannerSmall">
      <v-carousel :sum="marketBannerSmall.length" :hasDot="true">
        <div
          v-for="(item, index) in marketBannerSmall"
          :key="index"
          class="bannerpic"
        >
          <img :src="picUrl + item.pic" alt />
          <span>{{ item.title }}</span>
        </div>
      </v-carousel>
    </div>
    <v-comright></v-comright>
  </div>
</template>

<script>
import url from '@/axios/url'
import vCarousel from '@/components/common/Carousel'
import VComright from '@/components/common/Right'

export default {
  data () {
    return {
      picUrl: url.picUrl
    }
  },
  components: {
    vCarousel,
    VComright
  },
  props: ['marketBannerSmall', 'marTop']
}
</script>

<style scoped>
@import "../../assets/css/recomendRight2.css";
</style>



// WEBPACK FOOTER //
// src/components/education/Right2.vue